// API Configuration
// In development, use localhost:5001
// In production, use empty string (same origin through Nginx proxy)
const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production" ? "" : "http://localhost:5001");

export { API_BASE_URL };
export const API_URL = `${API_BASE_URL}/api`;

export default {
  baseURL: API_BASE_URL,
  apiURL: API_URL,
};
